// eslint-disable-next-line import/prefer-default-export
export const API_URI = process.env.REACT_APP_API_URI;
